/**
 * rich-text-link — poser, MODIFIER ou retirer le lien de la sélection tiptap
 * (bulle inline et éditeur modal appellent le même helper).
 *
 * Le bouton « lien » demandait une adresse sur une invite VIDE et n'agissait
 * que sur une réponse non vide : un lien déjà présent — la politique de
 * confidentialité d'une page de préférences, par exemple — ne pouvait donc être
 * ni relu ni corrigé depuis le canevas, seulement recouvert par une nouvelle
 * adresse tapée de mémoire, et jamais retiré. L'invite est désormais
 * PRÉREMPLIE avec l'adresse en place, et les deux réponses particulières ont
 * chacune leur sens : annuler ne touche à rien, valider à vide retire le lien.
 */

/**
 * @param {import('@tiptap/react').Editor} editor
 */
export function promptLink(editor) {
  if (!editor) return
  const current = editor.getAttributes('link').href || ''
  const url = window.prompt('Link URL:', current)
  // `null` = annulation, à distinguer de la chaîne vide qui, elle, est un ordre.
  if (url === null) return
  const chain = editor.chain().focus()
  if (url.trim() === '') {
    chain.unsetLink().run()
    return
  }
  chain.setLink({ href: url.trim() }).run()
}
